export const theme = {
  values: {
    colors: {
      brand: '#2563eb',
      brandLight: '#3b82f6',
      brandDark: '#1e40af',
      black: '#000000',
      white: '#ffffff',
      gray: {
        100: '#f7f7f7',
        200: '#e6e6e6',
        300: '#cccccc',
        400: '#999999',
        500: '#666666',
        600: '#333333',
        700: '#222222',
        800: '#1a1a1a',
        900: '#111111',
      }
    }
  },
  colors: {
    brand: {
      primary: 'text-[#2563eb]',
      light: 'text-[#3b82f6]',
      dark: 'text-[#1e40af]',
      bg: 'bg-[#2563eb]',
    },
    background: {
      primary: 'bg-[#0a0a0a]',
      secondary: 'bg-[#111111]',
      card: 'bg-[#161616]',
      elevated: 'bg-[#1e1e1e]',
    },
    text: {
      primary: 'text-[#ffffff]',
      secondary: 'text-[#cccccc]',
      tertiary: 'text-[#999999]',
      brand: 'text-[#2563eb]',
    },
    border: {
      primary: 'border-[#2563eb]',
      secondary: 'border-[#333333]',
      divider: 'border-[#222222]',
    },
    state: {
      hover: 'hover:text-[#3b82f6] hover:border-[#3b82f6]',
      active: 'active:text-[#1e40af] active:border-[#1e40af]',
      disabled: 'disabled:text-[#666666] disabled:border-[#333333]',
    },
    overlay: {
      light: 'bg-opacity-10',
      medium: 'bg-opacity-20',
      heavy: 'bg-opacity-30',
    }
  },
  effects: {
    glow: {
      sm: 'shadow-[0_0_15px_rgba(37,99,235,0.15)]',
      md: 'shadow-[0_0_25px_rgba(37,99,235,0.25)]',
      lg: 'shadow-[0_0_35px_rgba(37,99,235,0.35)]',
    },
    blur: {
      sm: 'backdrop-blur-sm',
      md: 'backdrop-blur-md',
      lg: 'backdrop-blur-lg',
    }
  },
  gradients: {
    brand: 'bg-gradient-to-r from-[#2563eb] to-[#1e40af]',
    glow: 'bg-gradient-to-r from-[#2563eb]/20 via-transparent to-[#2563eb]/20',
    card: 'bg-gradient-to-br from-[#161616] to-[#1a1a1a]',
  },
  animations: {
    hover: 'transition-all duration-300 ease-out',
    fade: 'transition-opacity duration-300 ease-out',
    scale: 'transition-transform duration-300 ease-out',
  },
  components: {
    button: {
      primary: `
        inline-flex items-center justify-center
        px-4 py-2 text-sm font-medium
        bg-gradient-to-r from-[#2563eb] to-[#1e40af]
        hover:from-[#3b82f6] hover:to-[#2563eb]
        text-white
        rounded-lg
        shadow-lg shadow-[#2563eb]/20
        hover:shadow-[#2563eb]/30
        transition-all duration-300
        border border-transparent
      `,
      secondary: `
        inline-flex items-center justify-center
        px-4 py-2 text-sm font-medium
        bg-[#1a1a1a]
        text-[#2563eb]
        hover:bg-[#2563eb]/10
        border border-[#2563eb]/30
        hover:border-[#2563eb]
        rounded-lg
        shadow-lg shadow-[#2563eb]/10
        hover:shadow-[#2563eb]/20
        transition-all duration-300
      `,
      outline: `
        inline-flex items-center justify-center
        px-4 py-2 text-sm font-medium
        bg-transparent
        text-gray-400
        hover:text-[#2563eb]
        border border-gray-700
        hover:border-[#2563eb]
        rounded-lg
        transition-all duration-300
      `,
    },
    card: {
      primary: 'bg-[#111111] border border-[#333333] rounded-xl',
      hover: 'hover:border-[#2563eb] hover:shadow-[0_0_20px_rgba(37,99,235,0.2)] transition-all duration-300',
      gradient: 'bg-gradient-to-br from-[#161616] to-[#1a1a1a]',
      content: 'bg-[#161616]/80 backdrop-blur-md',
      glow: 'shadow-[0_0_25px_rgba(37,99,235,0.1)]',
    },
    input: {
      primary: `
        bg-[#1a1a1a]/80 border border-[#333333] 
        rounded-lg focus:border-[#2563eb] 
        shadow-[0_0_15px_rgba(37,99,235,0.1)]
        focus:shadow-[0_0_20px_rgba(37,99,235,0.2)]
        transition-all duration-300
      `,
    }
  },
  buttons: {
    primary: 'inline-flex items-center justify-center px-6 py-3 text-white font-semibold bg-[#2563eb] rounded-xl hover:bg-[#3b82f6] transition-all duration-300',
    secondary: 'inline-flex items-center justify-center px-6 py-3 font-semibold text-[#2563eb] border-2 border-[#2563eb] rounded-xl hover:bg-[#2563eb] hover:text-white transition-all duration-300',
    outline: 'inline-flex items-center justify-center px-6 py-3 font-semibold text-white border-2 border-white rounded-xl hover:border-[#2563eb] hover:text-[#2563eb] transition-all duration-300',
  }
};
